<!-- TEMPLATE -->
<template>
  <div class="product-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>KPN Products</span>
            </span>

          <dean-section-title-item
              :icon='plusIcon'
              :content="true"
              @click.native="sectionRoute('standingData.kpnProducts.add')"
          >
            KPN product toevoegen
          </dean-section-title-item>
        </dean-section-title>

        <dean-table
            :data='productsData'
            :columns="columns"
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick($event, 'standingData.kpnProducts.edit')">
        </dean-table>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import { Component } from 'vue-property-decorator';
import deanTableMixin from '@/mixins/deanTableMixin';
import {mixins} from 'vue-class-component';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';

import {
  // ICONS
  plusIcon,
  // COMPONENTS
  deanSectionTitle,
  deanSectionTitleItem,
  deanTable,
  deanPagination,
} from '@deanone/dean-components';
import {requestKpnProducts} from "@/store/standingData/actions";

@Component({
  components: {
    plusIcon,
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
    deanFormRow,
  },
})

export default class List extends mixins(deanTableMixin) {
  public products: any = [];
  public plusIcon: object = plusIcon;
  public queryTimeout!: number;

  // COMPUTED
  get productsData() {
    return this.products;
  }

  public columns: any = {
    name: {
      content: 'Name',
      sort: true,
      align: 'left',
    },
    subscriptionType: {
      content: 'Subscription Type',
      sort: true,
      align: 'left',
    },
    dataUsageNotification: {
      content: 'Data Usage Notification',
      sort: false,
      align: 'left',
    },
    blockData: {
      content: 'Block Data',
      sort: false,
      align: 'left',
      formatter: (value: boolean) => value ? 'Yes' : 'No'
    }
  };

  get sideMenu(): object {
    return {
      title: {
        text: 'KPN Products',
        mobile: {
          close: {
            text: 'Close',
          },
        },
      },
      filters: {},
    };
  }

  public tableName(): string {
    return 'settings-kpn-products';
  }

  // METHODS
  public loadList(): void {
    this.$store.dispatch('setLoadOverlay', true);
    this.$store.dispatch('requestKpnProducts')
        .then(
            (response: any) => {
              this.products = response.data.map((product: any) => {
                return {
                  id: product.uuid,
                  name: product.name,
                  subscriptionType: product.subscriptionType,
                  dataUsageNotification: product.dataUsageNotification,
                  blockData: product.blockData
                };
              });
            },
            (error: any) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            },
        )
        .finally(
            () => {
              this.$store.dispatch('setLoadOverlay', false);
            },
        );
  }

  public cellClick(target: any): void {
    this.$router.push({
      name: 'standingData.kpnProducts.edit',
      params: {id: target.row.id},
    });
  }

  public created() {
    this.setDefaultSort('name');
    this.loadList();
    this.$store.dispatch('setStandingDataSideMenu', this.sideMenu);
  }

  public update(timeout: boolean) {
    if (timeout) {
      if (this.queryTimeout) {
        clearTimeout(this.queryTimeout);
      }
      this.queryTimeout = setTimeout(() => {
        this.loadList();
      }, 500);
    } else {
      this.loadList();
    }
  }
}
</script>
<!-- STYLE -->
<style lang="scss" scoped>
@import '~@deanone/dean-components/src/scss/vars';

filter {
  display: flex;
}

.top-bar {
  display: inline-block;
}
</style>